
import request from '@/utils/request'
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const {max, offset, ...rest} = params;
  const newParams = {take: max, skip: offset, ...rest};
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }
  //console.log(`api.member.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/member?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
function get (itemId) {
  return request({
    url: `/member/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/member/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/member/${itemId}?relation=groups`,
    method: 'get'
  })
}
function availability (params) {
  const qsParams = new URLSearchParams();
  qsParams.append('username', params);
  return request({
    url: `/member/availability?${qsParams.toString()}`,
    method: 'get',
  })
}
function add (params) {
  ENABLE_API_DBG && console.log(`api.member.add: params = ${JSON.stringify(params)}`)
  return request({
    url: `/member`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/member/${params.id}`,
    method: 'patch',
    data: params
  })
}
function remove (itemId) {
  return request({
    url: `/member/${itemId}`,
    method: 'delete'
  })
}
function reset (itemId) {
  return request({
    url: `/member/${itemId}/reset-timestamp`,
    method: 'post'
  })
}
export default {
  list,
  add,
  update,
  remove,
  get,
  getWithTags,
  getWithGroups,
  availability,
  reset,
}
